(function () {
  const parentSelector = ".product-info > .media-gallery .slider";
  
  function hideVideoControls(node) {
    node.controls = false;
  }

  function getVideoAddedMutationObserver() {
    return new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeName === "VIDEO") {
              hideVideoControls(node);
            }
            if (node.nodeType === Node.ELEMENT_NODE) {
              node.querySelectorAll("video").forEach(hideVideoControls);
            }
          });
        }
      });
    });
  }
  
  document.addEventListener("DOMContentLoaded", function () {
    const videos = document.querySelectorAll('video');
    videos.forEach(hideVideoControls);
    const observer = getVideoAddedMutationObserver();
    const parentElement = document.querySelector(parentSelector);
    if (parentElement) {
      observer.observe(parentElement, {
        childList: true,
        subtree: true,
      });
    } else {
      console.error('[hide-video-controls.js]: Parent element with ID "content" not found.');
    }
  });
})();

